import React, { Component } from "react";
import { connect } from "react-redux";
import StyledCheckbox from "../../Shared/StyledCheckbox";
import DropDownMenu from "../../Shared/DropDownMenu";
import { SupportedDocumentTypeService } from "oasis-document-viewer";

class TRCardView extends Component {
  state = {
    isExpanded: false,
    isChecked: false,
  };

  render() {
    const {
      item,
      isChild,
      User,
      downloadDocument,
      viewDocument,
      canPreviewDocument,
      _,
    } = this.props;

    const { isExpanded } = this.state;
    const {
      itemId,
      itemCode,
      category,
      center,
      departmentName,
      customerName,
      refValues,
      hasFiles,
      children,
      fileName,

      status,
    } = item;

    const refKeys = Object.keys(refValues);

    const supportedDocumentTypeService = new SupportedDocumentTypeService({});
    const previewDocument =
      supportedDocumentTypeService.canPreviewDocument(item);

    return (
      <>
        <div className="d-flex content-details mt-2" key={itemCode}>
          <div
            className={
              isChild
                ? "storage-contents-opened d-flex row"
                : "storage-contents d-flex row"
            }
          >
            <div className="d-flex col-3 box-details">
              <div className="check-button">
                <StyledCheckbox
                  checked={this.state.isChecked}
                  onChange={() =>
                    this.setState({ isChecked: !this.state.isChecked }, () =>
                      this.props.updateSelectedItems(
                        itemId,
                        this.state.isChecked
                      )
                    )
                  }
                />

                <button
                  className="dropdown-toggle portlet-menu-button"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                ></button>
              </div>
              {children && children.length > 0 && (
                <div className="arrow">
                  {!isExpanded ? (
                    <i
                      className="icon-omni-down-arrow"
                      onClick={() => this.setState({ isExpanded: true })}
                    ></i>
                  ) : (
                    <i
                      className="icon-omni-up-arrow"
                      onClick={() => this.setState({ isExpanded: false })}
                    ></i>
                  )}
                </div>
              )}

              <div
                className={
                  children && children.length
                    ? "document-and-number"
                    : "document-and-number without-arrow"
                }
              >
                <i
                  className={
                    "icon-omni-" + category.toLowerCase().trim() + "-min"
                  }
                ></i>
              </div>

              <div className="content-list-view box-details-2">
                <ul className="list-group col-11 ">
                  <li className="list-group-item d-flex ">
                    {_.ClientHub.ItemCode}:{" "}
                    <span className="grey-details">{itemCode}</span>
                  </li>
                  <li className="list-group-item d-flex  ">
                    {_.ClientHub.Customer}{" "}
                    <span className="grey-details">{customerName}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-3">
              <div className="content-list-view box-details">
                <ul className="list-group col-11">
                  <li className="list-group-item d-flex justify-content-between ">
                    {_.ClientHub.DepartmentName}:{" "}
                    <span className="grey-details">{departmentName}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between ">
                    FBU: <span className="grey-details">{center}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between ">
                    {_.ClientHub.Status}:{" "}
                    <span className="grey-details">{status}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-3">
              <div className="content-list-view box-details">
                <ul className="list-group col-11">
                  {refKeys
                    .slice(0, Math.round(refKeys.length / 2))
                    .map((ref, i) => (
                      <li
                        key={i}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        {ref}:{" "}
                        <span className="grey-details">{refValues[ref]}</span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            <div className="col-3">
              <div className="content-list-view box-details">
                <ul className="list-group col-11">
                  {refKeys
                    .slice(Math.round(refKeys.length / 2), refKeys.length)
                    .map((ref, i) => (
                      <li
                        key={i}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        {ref}:{" "}
                        <span className="grey-details">{refValues[ref]}</span>
                      </li>
                    ))}
                </ul>
                <DropDownMenu
                  className="portlet-menu"
                  BtnClass="portlet-menu-button"
                  Items={[
                    {
                      Text: "View in Bridge",
                      attr: {
                        onClick: () => this.props.viewInBridge([itemId]),
                      },
                    },
                    ...(hasFiles
                      ? [
                          {
                            Text: previewDocument
                              ? "View Document"
                              : "Download Document",
                            attr: {
                              onClick: () => {
                                if (previewDocument) viewDocument(item);
                                else {
                                  downloadDocument(itemId, fileName);
                                }
                              },
                            },
                          },
                        ]
                      : []),
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
        {isExpanded &&
          children &&
          children.length > 0 &&
          children.map((child) => (
            <TRCardView
              key={child.itemId}
              itemId={child}
              item={child}
              isChild={true}
              User={User}
              viewInBridge={this.props.viewInBridge}
              updateSelectedItems={this.props.updateSelectedItems}
              viewDocument={viewDocument}
              downloadDocument={downloadDocument}
              _={_}
            />
          ))}
      </>
    );
  }
}
export const mapStateToProps = ({ _, User }) => ({ _, User });
export default connect(mapStateToProps)(TRCardView);
